<template>
  <o-panel-link :path="`/order/${sale.idOrder}`" class="block p-4 hover:bg-blue-100 dark:hover:bg-blue-950 transition-colors duration-200 rounded-xl">
    <div class="flex justify-between items-center flex-grow">
      <div>
        <h5 class="font-medium">
          #{{ sale.orderNumber }}
        </h5>
        <p class="text-sm">
          {{ sale.dateLabel }}
        </p>
      </div>

      <div class="pl-6 flex items-center">
        <div class="flex items-center space-x-2">
          <o-chip v-if="isPaid" variant="success" flat>
            {{ $t('general.paid') }}
          </o-chip>
          <o-chip :variant="variant" flat>
            {{ sale.statusLabel || '-' }}
          </o-chip>
        </div>
        <p class="ml-4">
          <strong class="mr-3">{{ sale.priceLabel }}</strong>
        </p>
      </div>
    </div>
  </o-panel-link>
</template>

<script setup lang="ts">
interface Props {
  sale: Record<string, any>
}

const props = defineProps<Props>()

const isPaid = computed(() => props.sale.isPaid)

const variant = computed(() => {
  const status = props.sale.statusLabel

  switch (status) {
    case 'Open':
      return 'warning'
    case 'Closed':
      return 'success'
    default:
      return 'info'
  }
})
</script>
